import TpPlatformInvoiceStatusesEnum from '../Enums/TpPlatformInvoiceStatusesEnum';

// Derives the display status of a mirrored platform invoice.
// Precedence: Ignored (manually dismissed) > Summarized (aggregated) > Pending.
export function getPlatformInvoiceStatus(summarizedOnUtc?: string | null, ignoredOnUtc?: string | null): string {
  if (ignoredOnUtc) {
    return TpPlatformInvoiceStatusesEnum.Ignored;
  }
  if (summarizedOnUtc) {
    return TpPlatformInvoiceStatusesEnum.Summarized;
  }
  return TpPlatformInvoiceStatusesEnum.Pending;
}
